import httpWrapper from '../HttpWrapper'
import { GerPersonByIdRes } from './models/get/SearchPersonsRes'
import { GetPersonByIdsRes } from './models/getByIds/GetPersonByIdsRes'
import { CandidatesBooleanSearchRes } from './models/getCandidatesBooleanSearch/CandidatesBooleanSearch'
import { GetHelixSearchResultsReq } from './models/getHelixSearchResults/GetHelixSearchResultsReq'
import { GetHelixSearchResultsRes } from './models/getHelixSearchResults/GetHelixSearchResultsRes'
import {
    GetHelixSearchResultTotalOnlyReq,
    GetHelixSearchResultTotalOnlyRes,
} from './models/getHelixSearchResultsCountOnly/GetHelixSearchResultsCountOnlyDtos'
import { GetHelixSearchSessionRes } from './models/getHelixSearchSession/GetHelixSearchSessionRes'
import { GetPersonsLiteReq } from './models/getLite/GetPersonsLiteReq'
import { GetPersonsLiteRes } from './models/getLite/GetPersonsLiteRes'
import { SearchPersonsRes } from './models/search/SearchPersonsRes'
import { StartNewHelixSearchReq } from './models/startNewHelixSearch/StartNewHelixSearchReq'
import { StartNewHelixSearchRes } from './models/startNewHelixSearch/StartNewHelixSearchRes'
import { UpdateHelixSearchReq } from './models/updateHelixSearch/UpdateHelixSearchReq'

class PersonApi {
    private static instance: PersonApi

    public constructor() {
        if (PersonApi.instance) {
            return PersonApi.instance
        }

        PersonApi.instance = this
    }

    public async searchPersons(searchTerm: string): Promise<SearchPersonsRes> {
        const queryParams = new URLSearchParams({
            q: searchTerm,
        })

        return await httpWrapper.get<SearchPersonsRes>(
            '/person/search',
            queryParams,
        )
    }

    public async getNumberOfPersonNodes(): Promise<number> {
        return await httpWrapper.get('/person/count')
    }

    public async getPersonsLite(
        data: GetPersonsLiteReq,
    ): Promise<GetPersonsLiteRes> {
        if (data.personIds.length === 0) {
            return { persons: [] }
        }

        return await httpWrapper.post('/person/get-lite', data)
    }

    public async getPersonById(personId: string): Promise<GerPersonByIdRes> {
        const queryParams = new URLSearchParams({ personId })
        return await httpWrapper.get<GerPersonByIdRes>(
            '/person/get-by-id',
            queryParams,
        )
    }

    public async getPersonsById(
        personIds: string[],
    ): Promise<GetPersonByIdsRes> {
        const queryParams = new URLSearchParams()
        personIds.forEach((id) => queryParams.append('personIds', id))
        return await httpWrapper.get<GetPersonByIdsRes>(
            '/person/get-by-ids',
            queryParams,
        )
    }

    public async getCandidatesBooleanSearch(
        searchTerm: string,
        ignoreRetiredPeople: boolean = false,
        ids: string[] = [],
    ): Promise<CandidatesBooleanSearchRes> {
        const queryParams = new URLSearchParams({
            query: searchTerm,
            ignoreRetiredPeople: ignoreRetiredPeople.toString(),
            ids: ids.toString(),
        })

        return await httpWrapper.get<CandidatesBooleanSearchRes>(
            '/person/get-persons-boolean-search',
            queryParams,
        )
    }

    public async startNewHelixSearch(
        req: StartNewHelixSearchReq,
    ): Promise<StartNewHelixSearchRes> {
        return await httpWrapper.post(
            '/person-search/start-new-helix-search',
            req,
        )
    }

    public async updateHelixSearch(req: UpdateHelixSearchReq): Promise<void> {
        await httpWrapper.post('/person-search/update-helix-search', req)
    }

    public async getHelixSearchSession(
        searchSessionToken: string,
    ): Promise<GetHelixSearchSessionRes> {
        const queryParams = new URLSearchParams({
            sst: searchSessionToken,
        })
        return await httpWrapper.get<GetHelixSearchSessionRes>(
            '/person-search/get-search-session',
            queryParams,
        )
    }

    // TODO : 77 - Add pagination + FILTERS
    public async getHelixSearchResults(
        req: GetHelixSearchResultsReq,
    ): Promise<GetHelixSearchResultsRes> {
        return await httpWrapper.post(
            '/person-search/get-helix-search-results',
            req,
        )
    }

    public async getHelixSearchResultsCountOnly(
        res: GetHelixSearchResultTotalOnlyReq,
    ): Promise<GetHelixSearchResultTotalOnlyRes> {
        return await httpWrapper.post(
            '/person-search/get-helix-search-results-count-only',
            res,
        )
    }
}

const personApi = new PersonApi()
export default personApi
